import styled from 'styled-components';
import { LastModified } from '../../../../../components/PlanCard/LastRow/styles';

export const City = styled(LastModified)`
    padding: 12px 8px;
    height: auto;
    flex: none;
`;

export const WantedVoices = styled(City)`
`;